export default (function (app) { return function (to, from, next) {
    // If the user is already authenticated, don't redirect to login.
    if (app.authenticator.getToken()) {
        return next();
    }
    // If it's the unauthenticated routes or the error pages, don't redirect to login.
    if (['Setup.', 'Auth.', 'Error.', 'Public.'].some(function (name) { var _a; return (_a = to.name) === null || _a === void 0 ? void 0 : _a.startsWith(name); }) && to.name !== 'Error.CatchAll') {
        return next();
    }
    return app.redirectToLogin();
}; });
